import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";


export class CustomSlideShowPage extends SlideShowPage {
    constructor(texture?: PIXI.Texture, textString?: string, backgroundColor?: number, imageLeft?: boolean, center:boolean = true){
        super();

        if (center && texture != undefined) {
            const image = new PIXI.Sprite(texture);
            image.anchor.x = 0.5;
            image.anchor.y = 0.5;
            image.position.x = 0;
            this.addChild(image);
        }
    }
}